import React from 'react'
import blogging  from '../../image/eb.jpg'

import leaf from '../../image/back/leaf.png'   

import ParticlesBg from "particles-bg";
 

const Aboutcard1 = () => {
	return (
		<div>
			


<ParticlesBg type="cobweb"   bg={true}/>  
           
         
<div class="card-title" > <p class="heading-num">01   </p>
</div>
 <h2 class="heading heading--top"><h1>WHO I AM</h1></h2>
	<div class="container" >
 
<div class="row" >
    
     <div class="col-md-6 "     style={{  color: 'black ' , borderRadius:'20px',fontFamily:'Comic Sans MS',background:"linear-gradient(to right, #F0FDFF, #FFF8F8 80% )" }} >
			    
			  <p style={{fontSize:'20px', marginTop:'30px'}}>I graduated with a bachelor of science degree in  Chemical Engineering and Polymer Science from the Shahjalal University of Science and Technology Sylhet, Bangladesh. I have strong technical skills and an academic background in engineering process simulation and design, calibration and safety management and control. Skilled in reporting, documentation and identifying key project milestones.</p>
			  <img src={leaf} class='leaf' alt={""}></img>
	     </div>
     

     <div class="col-md-6  "  >
        
        <div class="card-body">
					<img  class="img-fluid" alt={""}
					style={{transform:"translate(-20px, -10px)", height:'100%', width:'100%', filter: 'drop-shadow(black 6px 9px 10px)'}}     
					src={blogging}>
					</img>
	 
        </div>    
	   </div>

	  </div>         
     
 </div>


		</div>   
	)
}

export default Aboutcard1